"use strict";

exports.__esModule = true;
var _TicketWatcherRuleForm = require("./TicketWatcherRuleForm");
Object.keys(_TicketWatcherRuleForm).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TicketWatcherRuleForm[key]) return;
  exports[key] = _TicketWatcherRuleForm[key];
});